import { createApi } from '@reduxjs/toolkit/query/react';
import EnhancedBaseQuery from '../../Api/createApiConfig';

const loginApi = createApi({
    reducerPath: 'loginApi',
    baseQuery: EnhancedBaseQuery,
    endpoints: () => ({}),
});

const injectedLoginApi = loginApi.injectEndpoints({
    endpoints: (builder) => ({
        loggedInUserValidate: builder.mutation({
            query: (data) => ({
                url: '/loggedinuservalidate',
                method: 'POST',
                body: data,
            }),
        }),
        loggedInOtpVerify: builder.mutation({
            query: (data) => ({
                url: '/loggedinotpverify',
                method: 'POST',
                body: data,
            }),
        }),
        getToken: builder.mutation({
            query: (data) => ({
                url: '/api/token',
                method: 'POST',
                body: data,
            }),
        }),
        getprofile: builder.mutation({
            query: () => ({
                url: '/users/profile',
                method: 'POST',
            }),
        }),
        forgotPassword: builder.mutation({
            query: (data) => ({
                url: '/forgotpassword',
                method: 'POST',
                body: data,
            }),
        }),
        changePassword: builder.mutation({
            query: (data) => ({
                url: '/profile/password/reset',
                method: 'POST',
                body: data,
            }),
        }),
        emailValidate: builder.mutation({
            query: (data) => ({
                url: '/admin/emailvalidate',
                method: 'POST',
                body: data,
            }),
        }),
        otpVerify: builder.mutation({
            query: (data) => ({
                url: '/admin/otpverify',
                method: 'POST',
                body: data,
            }),
        }),

    }),
    overrideExisting: false,
});

export const {
    useLoggedInUserValidateMutation,
    useLoggedInOtpVerifyMutation,
    useGetTokenMutation,
    useGetprofileMutation,
    useForgotPasswordMutation,
    useChangePasswordMutation,
    useEmailValidateMutation,
    useOtpVerifyMutation,

} = injectedLoginApi;

export default loginApi;